<!--
 * @Author: your name
 * @Date: 2021-04-20 17:21:49
 * @LastEditTime: 2021-04-23 09:39:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/custom/sealApproval/index.vue
-->
<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
        <el-menu-item index="0">待审核</el-menu-item>
        <el-menu-item index="1">已审核</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
        <waitingList v-if="activeIndex == '0'" :sealType="activeIndex"></waitingList>
        <completeList v-if="activeIndex == '1'" :sealType="activeIndex"></completeList>
      </div>
    </div>
  </div>
</template>

<script>
import waitingList from "./list";
import completeList from "./list";
export default {
  data() {
    return {
      activeIndex: "0",
    };
  },
  components: {
    waitingList,
    completeList
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
  },
 
}
</script>